import { Link } from 'react-router-dom';
import { HiCheckCircle } from 'react-icons/hi';

import Navbar from '../../components/navbar';
import Footer from '../../components/footer';
import './styles.css';

const MailSuccess = () =>{
  return(
    <>
    <header
    className="container-fluid bg-primary headerExtra"
    id="home">
      <div className="container h-100">
      <Navbar />
        <div className="d-flex flex-column align-items-center justify-content-center h-75 text-white">
          <h1 className="display-4">
            Mail Success
          </h1>
          <div>
            <Link
            className="text-white mx-2"
            to="/home01">
              Home
            </Link>
              &#11166;
            <Link
            className="text-white mx-2"
            to="/Mail">
              Mail Success
            </Link>
          </div>
        </div>
      </div>
    </header>
    <div className="container d-flex justify-content-center">
      <div className="col-12 col-md-10 col-xl-6 bg-white box shadow-lg division2 d-flex flex-column align-items-center">
        <HiCheckCircle
        size={64}
        className="check-circle"
        style={{fill: 'var(--primary)'}}
        />
        <h2 className="text-center text-gray-dark font-weight-bolder">
          Success!
        </h2>
        <p className="text-center paragraph mt-3">
          Thank you so much for your message. We check e-mail frequently and will try our best to respond to your inquiry.
        </p>
        <Link
        to="/home01"
        className="btn btn-primary mt-3">
          Go Home
        </Link>
      </div>
    </div>
    <Footer />
    </>
  );
};
export default MailSuccess;